<template>
  <div class="case-content">
      <div class="intro-tekst">
        <slot name="intro-tekst"></slot>
      </div>
      <div class="case-img">
        <slot name="case-img"></slot>
      </div>
    </div>
</template>

<script>

export default {
  name: 'titelVideoBig',
}
</script>

<style lang="scss" scoped>

.intro-tekst{
  h2{
    text-align: center;
  }
  p{
    max-width: 680px;
    margin: 0 auto;
    margin-bottom: layout-val-8(4);
    display: block;
    text-align: center;
  }
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  overflow: hidden;
}
		
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

</style>